
import React, { useEffect, useState, useImperativeHandle, forwardRef} from 'react'
import styled from "styled-components";

// import { RewardContent, IconClose } from './style'
// import FloatLayout from "@/components/float-layout";
import close from '@/img/activity22/close.png'
import bgd from '../imgs/19@2x.png'
import bgd3 from '../imgs/user.png'
// import bridge from '@/config/JSbridge'
// import bwmodel from '@/config/bwmodel';
import { fetchHasparticipate, fetchParticipate } from '../api'


import { Modal } from 'antd-mobile'

// const isStorm = bwmodel.app === 'storm';

const Desc = ({activityId,userInfo, token, goEidt}, ref) => {
	const [descVisible, setDescVisible] = useState(false);

	const [hasparticipate, setHasparticipate] = useState(false);

	useEffect(( ) => {
	
		const params = {
			"activityId": 130,
		}
		fetchHasparticipate(params)
			.then(res => {
				setHasparticipate(res.data)
			})
	}, [])

	// const handleLogin = () => {
	// 	if(!isStorm) {
	// 		window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
	// 	}
  //   bridge.callHandler(
  //     'nativeEvent',
  //     {
  //       event: 'login',
  //       params: {
  //         refreshOnBack: true
  //       }
  //     },
  //     () => {}
  //   );
  // }

	const showModal = async () => {
		
	
		console.log('userInfo', userInfo);
		
		setDescVisible(true)
	}

	const handleApply = () => {

		const params = {
			"activityId": 130,
		}
		fetchParticipate(params)
			.then(res => {
				setHasparticipate(true)
			})
	}

	useImperativeHandle(ref, () => {
		return {
			show: () => {
				showModal();
			}
		}
	})
	
	

	return (

			<Modal 
				visible={descVisible} 
				wrapClassName="rw-desc-modal-outer" className={'lx-desc-modal long-modal'} 
				style={{width: 'calc(100% - 40px)'}}
				transparent onClose={() => setDescVisible(false)}>
				<Ctitle>
						{/* <div >我的奖励</div> */}
					</Ctitle>
					<IconClose onClick={() => setDescVisible(false)} />
					<Content>
						<div className='bg1'></div>
						<div className='content'>
				
						<div className='header'>  
							{/* <div className='avatar'>
									<div className='avatar-img'></div>
							</div> */}
							<div class="avatar-wrapper">
								<img src={userInfo.avatar } alt="Avatar" class="avatar"/>
								<div class="avatar-frame"></div>
							</div>

							
							<div className='user'>{userInfo.nickname}</div>
						</div>
					<div>
						<img className='title' src={require('../imgs/title2.png')} alt=''/>
					</div>
					{
						!hasparticipate? (
						<div >
							<div className='tips2 tips3'>【申请须知】：如果发布5篇以上非原创内容，平台将取消原创激励资格，并将清零创作分，次月可重新申请</div>
							<div className='btns'>
								<div className='btn btn2' onClick={() => setDescVisible(false)} >取消申请</div>
								<div className='btn' 
									onClick={() => {
										handleApply()
									}}
								>确认申请</div>
							</div>
						</div>
						): (
						<div>
							<div className='tips2'>权益已生效</div>
							<div className='btns'>
								<div className='btn' onClick={() => {goEidt()}}>发布原创内容</div>
							</div>
						</div>
						)
					}
							</div>
					</Content>
			
			</Modal>
			
	)
}


export default React.memo(forwardRef(Desc));
// export default React.memo(forwardRef(Desc));

export const ModalEntrance= styled.div`
	height: 90vh;
	.content {
		width: 88.8vw;
		height: 125vw;
		background-image: url(${bgd});
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
		margin:auto;
		padding-top: 37vw;
		padding-left: 3vw;
		padding-right: 3vw;
		box-sizing: border-box;
		img {
			height: 33.8vw;
			display: block;
			margin:auto;
		}
		h1 {
			font-weight: 800;
			font-size: 40px;
			color: #626162;
			line-height: 1.1;
			text-align:center;
			color: #FB5A00;
		}
		h3 {
			font-family: Alibaba PuHuiTi;
			font-weight: 800;
			font-size: 18px;
			color: #626162;
			line-height: 1.2px;
		}
		p {
			font-family: Alibaba PuHuiTi;
			font-weight: 400;
			font-size: 16px;
			color: #626162;
			line-height: 1;
		}
	}
	.btn {
		width: 155px;
		height: 46px;
		background: linear-gradient(181deg, #FF9B00 0%, #FF6D00 100%);
		font-family: Alibaba PuHuiTi;
		font-weight: 800;
		font-size: 24px;
		color: #FFFFFF;
		line-height: 46px;
		border-radius: 23px;
		text-align: center;
		margin:20px auto;
	}

`

export const Ctitle= styled.div`


`


export const Content= styled.div`
.bg1 {
	width: 100%;
	height: 50px;
	background: #FFD997;
	// background: linear-gradient( 180deg, #FFB330 1%, #FFFFFF 71%);
	border-radius: 20px 20px 0 0;
	overflow: hidden;
	// margin-top: -20px;
	transform: translateY(-20px);
	z-index: 1;
}
.content {
	position: relative;
	border-radius: 20px 20px 20px 20px;
	 background: linear-gradient( 180deg, #FFE9C3 1%, #FFFFFF 71%);
	padding: 0 20px;
	margin-top: -30px;
	z-index: 10;
}

// padding: 20px;
.header {
	text-align: center;
	font-weight: 500;
	font-size: 13px;
	color: #000000;
	line-height: 23px;
transform: translateY(-80px);
	z-index: 10;
}
.avatar-img {
	width: 72px;
	height: 72px;
	background: #FFC45D;
	background: red;
	border-radius: 50%;
	margin: 0 auto;
}

.avatar-wrapper {
  position: relative;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  transition: transform 0.4s ease;
}

.avatar-wrapper:hover {
  transform: scale(1.1);
}

.avatar-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${bgd3}); /* 边框图片 */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
  pointer-events: none;
}

.avatar {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%; /* 调整头像大小 */
  height: 70%; /* 调整头像大小 */
  border-radius: 50%;
  object-fit: cover;
  z-index: 1;
  border: 3px solid white;
	background: #FFC45D;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}
.title {
	width: 180px;
	margin: -60px auto 20px;
	display: block;
}
.tips2 {
	font-family: OPPO Sans 4.0, OPPO Sans 40;
	font-weight: bold;
	font-size: 14px;
	color: #DA3B32;
	line-height: 65rpx;
	text-align: center;
	padding: 0 40px;
	&.tips3 {	
	text-align: left;
	font-size: 10px;
	}
}
.btns {
	margin-top: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-bottom: 30px;
}

.btn {
	width: 180px;
	height: 40px;
	background: linear-gradient(#FFC665, #FFE6BC);
	border-radius: 25px;
	opacity: 1;
	text-align: center;
	line-height: 40px;
	font-size: 18px;
	color: #262626;
	font-weight: bolder;
}
.btn.btn2 {
	background: linear-gradient( 170deg, #FFE2AF 1%, #FFFFFF 71%);
	margin-right: 10px;
}
`

export  const IconClose = styled.div`
  width: 40px;
  height:40px;
  position: absolute;
  z-index: 300;
  bottom: -40px;
	left: calc(50% - 20px);
	z-index: 300;
  background-image: url(${close});
  background-size: 25px 25px;
  background-repeat: no-repeat;
  background-position: center center;

`


// WEBPACK FOOTER //
// ./src/views/activity_130/components/participate.js